import { useParams, useNavigate, Link } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import { useEffect, useState, useRef } from "react";

const EditUser = () => {
    const errRef = useRef();
    const [email, setEmail] = useState("");
    const [disabled, setDisabled] = useState(true);
    const [errMsg, setErrMsg] = useState("");

    const params = useParams();
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    useEffect(() => {
        const fetch = async () => {
            try {
                const response = await axiosPrivate.get(`/users/${params.userId}`, {headers: {Authorization: "Bearer " + auth.accessToken}});
                setEmail(response.data.email);
                setDisabled(response.data.disabled);
            } catch(err) {
                console.log(err);
            }
        }
        fetch();
    }, [auth.accessToken, axiosPrivate, params.userId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosPrivate.put(`/users/${params.userId}`, {email, disabled}, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/users");
        } catch(err) {
            console.log(err);
            if (!err?.response) {
                setErrMsg("No Server Response");
            } else if (err.response?.status === 400) {
                setErrMsg(err.response.data?.detail);
            } else if (err.response?.status === 401) {
                setErrMsg("Unauthorized");
            } else {
                setErrMsg("Request Failed");
            }
            errRef.current.focus();
        }
    }

    if (!email) {
        return <div>Loading...</div>
    }

    return (
        <div>
            <div style={{paddingBottom:'2rem'}}>
                <span className="relative flex justify-center">
                    <div className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-transparent bg-gradient-to-r from-transparent via-gray-500 to-transparent opacity-75"></div>
                    <span className="relative z-10 bg-white px-6">Edit User</span>
                </span>
            </div>
            <div style={{paddingBottom:'1.5rem'}}>
                <Link to="/users">
                    <strong className="rounded border border-[#f3f4f7] bg-[#f3f4f7] px-3 py-1.5 text-[13px] font-medium text-black">
                        Back
                    </strong>
                </Link>
            </div>
            <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
            <form onSubmit={handleSubmit}>
                <div style={{display:'grid', rowGap: '1rem'}}>
                    <div>
                        <label htmlFor="email" className="relative block overflow-hidden border-b border-gray-300 bg-transparent pt-3 focus-within:border-blue-600">
                            <input
                                type="text"
                                id="email"
                                autoComplete="off"
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                                required
                                placeholder="Email"
                                className="peer h-8 w-full border-none bg-transparent p-0 placeholder-transparent focus:border-transparent focus:outline-none focus:ring-0 sm:text-sm"
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                            Email
                            </span>
                        </label>
                    </div>
                    <div>
                        <label htmlFor="disabled" className="relative block overflow-hidden bg-transparent pt-3 ">
                            <input
                                type="checkbox"
                                id="disabled"
                                autoComplete="off"
                                onChange={(e) => setDisabled(e.target.checked)}
                                checked={disabled}
                            />
                            <span className="absolute start-0 top-2 -translate-y-1/2 text-xs text-gray-700 transition-all peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-sm peer-focus:top-2 peer-focus:text-xs">
                                Disabled
                            </span>
                        </label>
                    </div>
                    
                </div>
                <div style={{display:'flex', paddingTop:'2rem', justifyContent:'end'}}>
                    <button>
                        <strong className="rounded border border-indigo-500 bg-indigo-500 px-3 py-1.5 text-[13px] font-medium text-white">
                            Submit
                        </strong>
                    </button>
                </div>
            </form>
        </div>
    )
}

export default EditUser;